import { CacheProvider } from '@emotion/react';
import styled from '@emotion/styled';
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Switch,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import MUIDataTable from 'mui-datatables';
import React, { useContext, useEffect, useState } from 'react';
import AddButton from '../../components/300/AddButton';
import BasicTable from '../../components/300/BasicTable';
import PositionContext from '../../context/PositionContext';
import useAuth from '../../hooks/useAuth';
import EditIcon from '@mui/icons-material/Edit';

import createCache from '@emotion/cache';
import { NavLink, useNavigate } from 'react-router-dom';
import useAxiosPrivate from './../../hooks/useAxiosPrivate';
import ProfileContext from '../../context/ProfileContext';

const muiCache = createCache({
  key: 'mui',
  prepend: true,
});
function Position() {
  let navigate = useNavigate();
  let api = useAxiosPrivate();

  const { user } = useAuth();
  const profileContext = useContext(ProfileContext);
  const positionContext = useContext(PositionContext);
  const [modalState, setModalState] = useState({
    open: false,
    name: null,
    courseCode: null,
    disabled: null,
  });
  const [added, setAdded] = useState({ status: false });

  const handleClose = () => {
    setModalState({ ...modalState, open: false });
  };
  const handleOpen = (id) => {
    let position = positionContext.positionState.filter((p) => {
      return p.id === id;
    })[0];
    console.log(position);
    setModalState({
      name: position.title,
      id: position.id,
      open: true,
      disabled: !Number(position.status),
    });
  };
  const handleDisable = (id) => {
    //let curriculum = courseContext.curriculumState.filter((c) => {
    //  return c.id === modalState.id;
    //})[0];
    //let values = { ...curriculum, active: Number(modalState.disabled) };

    api
      .patch('/position/disablePosition', { id: modalState.id })
      .then((response) => {
        alert(JSON.stringify(response, null, 2));
        setAdded({ status: Boolean(response.data.status) });
      })
      .catch((err) => {
        alert(JSON.stringify(err.response.data, null, 2));
      });

    handleClose();
  };
  useEffect(() => {
    api.get('position/positions').then((res) => {
      //console.log(curriculum.data.curriculums);
      console.log(res);
      positionContext.positionDispatch({
        type: 'loadPosition',
        positions: res.data.positions,
      });
    });
  }, [added]);

  const columnHead = [
    {
      label: 'Title',
      name: 'title',
      options: {
        filter: true,
      },
    },
    {
      label: 'Full Name',
      name: 'full_name',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          console.log(tableMeta.tableData);
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
              <Avatar
                src={
                  profileContext?.state?.host +
                  tableMeta.tableData[tableMeta.rowIndex]?.profile_pic?.slice(1) +
                  `?token=${user?.accessToken}`
                }
              >
                {value}
              </Avatar>
              <Box sx={{ color: value.length > 0 ? '' : 'third.main' }}>
                {value.length > 0 ? value : 'Not assigned'}
              </Box>
            </Box>
          );
        },
      },
    },
    {
      label: 'Load',
      name: 'position_load',
      options: {
        filter: true,
      },
    },
    {
      label: 'Status',
      name: 'statusAlias',
      options: {
        filter: true,
        sort: false,
        display: 'none',
      },
    },
    {
      label: 'First Name',
      name: 'first_name',
      options: {
        filter: false,
        sort: false,
        display: 'none',
      },
    },
    {
      label: 'Middle Name',
      name: 'middle_name',
      options: {
        filter: false,
        sort: false,
        display: 'none',
      },
    },
    {
      label: 'Last Name',
      name: 'last_name',
      options: {
        filter: false,
        sort: false,
        display: 'none',
      },
    },
    {
      label: 'Profile',
      name: 'profile_pic',
      options: {
        filter: false,
        sort: false,
        display: 'none',
      },
    },
    {
      label: 'Staff Id',
      name: 'staff_id',
      options: {
        filter: false,
        sort: false,
        display: 'none',
      },
    },
    {
      label: 'Action',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ width: '100px', display: 'flex', alignItems: 'center' }}>
              {user.roles.includes(304) && (
                <EditIcon
                  color="primary"
                  onClick={() => {
                    navigate('editPosition', {
                      state: {
                        ...tableMeta.tableData[tableMeta.rowIndex],
                        id: value,
                      },
                    });
                  }}
                />
              )}
              {/*<NavLink to={`/deleteCourse/${value}`}>*/}
              {user.roles.includes(305) && (
                <Switch
                  checked={Number(
                    tableMeta.tableData.filter((row, index) => {
                      console.log(row);
                      if (row.id == value) {
                        return true;
                      }
                      return false;
                    })[0].status
                  )}
                  onClick={() => {
                    handleOpen(value);
                  }}
                />
              )}
              {tableMeta.tableData.filter((row) => {
                console.log(row.status);
              })}
              {/*</NavLink>*/}
            </div>
          );
        },
      },
      name: 'delete',
    },
  ];
  const options = {
    selectableRows: 'none',
  };

  let positions = positionContext.positionState.map((position) => {
    console.log('here is the ps', position);
    let full_name = '';
    if (position.first_name) {
      full_name += position.first_name + ' ';
    }
    if (position.middle_name) {
      full_name += position.last_name;
    }
    return {
      ...position,
      delete: position.id,
      statusAlias: Number(position.status) == 1 ? 'Active' : 'InActive',
      full_name: full_name,
    };
  });
  const StyledMUIDataTable = styled(MUIDataTable)(({ theme }) => ({
    background: theme.palette.background.default,
  }));

  return (
    <>
      <CacheProvider value={muiCache}>
        <StyledMUIDataTable
          title={'Position List'}
          data={positions}
          columns={columnHead}
          options={options}
        />
      </CacheProvider>

      <Dialog open={modalState.open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">
          {modalState.disabled ? 'Enable ' : 'Disable '}
          {modalState.name} ?
        </DialogTitle>
        <DialogContent>
          {modalState.disabled
            ? "You will be able to use it one's it is activated"
            : "once you disable it you won't be able to use it"}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} sx={{ color: 'teritiary.darker' }}>
            cancel
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleDisable}>
            {modalState.disabled ? 'Enable' : 'Disable'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Position;
